<template>
    <div class="ControlMap">
        <google-map v-if="map.mapApi === 1" class="MapZone" :adminAccess="false" v-on="$listeners" :Variant="Variant" :center.sync="googleMapCenter" :zoom.sync="googleMapZoom"></google-map>
        <arcgis-map v-if="map.mapApi === 2" :adminAccess="false"></arcgis-map>
    </div>
</template>

<script lang="ts">
    import { Prop, Vue } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';
    import map from '@/types/map/type-map';
    import Component from 'vue-class-component';
    import GoogleMap from './Map/gmap/GoogleMap.vue'
    import ArcgisMap from './Map/arcgis/ArcgisMap.vue'

    const CartoModule = namespace("CartoMod");


    @Component({
        name: 'control-map',
        components: {
            GoogleMap,
            ArcgisMap
        }
    })
    export default class Map extends Vue {
        @CartoModule.State
        private map!: map;

        private googleMapCenter: google.maps.LatLngLiteral = { lat: 48.8566969, lng: 2.3514616 };
		private googleMapZoom: number = 6;

        /** Variant de couleur à appliquer sur le composant */
		@Prop({default: () => "tertiary"})
		public Variant!: string;
    }

</script>

<style scoped>
    

    .ControlMap {
        box-sizing: padding-box;
        width: 100%;
        min-height: 200px;
        height: 100%;
        padding: 5px;
    }

    .MapZone {
        box-sizing: border-box;
        position: relative;
        display: block;
        z-index: 1;
        background-color: #40aa60;
        content: "map";
        width: 100%;
        min-height: 200px;
        height: 100%;
        text-align: center;
        color: #fefefe;
        padding: 2px;
        border-radius: 5px;
        box-shadow: 0px 0px 5px rgba(40,40,40,0.75);
    }
</style>